import { Mediator } from 'com-gyf-webcore-mediator';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Producto } from '../../Common/Producto';

import {
    GET_MENU_USUARIO_DATA,
    GET_MENU_USUARIO_DATA_SUCCESS,
    GET_MENU_USUARIO_DATA_FAILURE,
    RESET_MENU_PRODUCTOS,
    SET_PROGRAMA_ACTUAL,
    INITIAL_PRODUCTO_SELECTED_TOP_MENU,
    POP_UP_OPEN,
    POP_UP_PRODUCTO_SELECTED,
    POP_UP_PROGRAMA_OPEN,
    POP_UP_PROGRAMA_CLOSE,
    INITIAL_PROGRAM_SELECTED_TOP_MENU,
    INITIAL_PROGRAM_SAVE_TOP_MENU,
    ACCESO_DIRECTO_POP_UP_PROGRAMA,
    SET_FLAG_ACCESO_DIRECTO
} from '../../Screens/TopMenu/Actions';

const initialState = {
    menuUsuario: [],
    branchId: null,
    branchDescription: "",
    login: "",
    hostName: "",
    userName: "",
    tiempo: "",
    isFetching: false,
    error: false,
    lastProgram: null,

    startUpSelected: false, 
    productoId: null, 
    programCategories: [], 
    categorySelected: null,
    productoCodigo: null,
    productosCount: 0,
    defaultProducto: null,
    defaultPrograma: null,
    primerLogin: null,
    flagAccesoDirecto: false,
    solicitarContrasenia: false,
    tipoSeguridad: null,
    soloUsuarioLoggeado: false,
    menuLoaded: false
}

export function menuProductos(state = initialState, action) {
    LogHelper.In(menuProductos.name, state, action);

    switch (action.type) {

        case GET_MENU_USUARIO_DATA:
            LogHelper.Out(menuProductos.name);
            return { ...state, isFetching: true, menuLoaded: false };

        case GET_MENU_USUARIO_DATA_SUCCESS:
            var result = {
                'GET_MENU_BY_USUARIO_ID': JSON.parse(action.data.GET_MENU_BY_USUARIO_ID).Recordset0.Rows,
                'GetInitialData': JSON.parse(action.data.GetInitialData),
                'GET_ROUTE_BY_USUARIO_ID': JSON.parse(action.data.GET_ROUTE_BY_USUARIO_ID).Recordset0.Rows,
                'GET_PRODUCTO_USUARIO_LOGIN': JSON.parse(action.data.GET_PRODUCTO_USUARIO_LOGIN).Recordset0.Rows,
                'GET_CONFIGURATION_PASSWORD_TYPE': JSON.parse(action.data.GET_CONFIGURATION_PASSWORD_TYPE).Recordset0.Rows
            }

            let menuUsuario = JSON.parse(JSON.stringify(state.menuUsuario));

            result.GET_MENU_BY_USUARIO_ID.forEach(function (item) {
                let rowsPerProduct = result.GET_MENU_BY_USUARIO_ID.filter(
                    x => x.ProductoId === item.ProductoId
                );

                let index = menuUsuario.findIndex(x => x.id === item.ProductoId);
                if (index === -1) {
                    menuUsuario.push(new Producto(item.ProductoId, item.ProductoCodigo, rowsPerProduct));
                }
            });

            let routes = result.GET_ROUTE_BY_USUARIO_ID.length > 0 ?
                ('#/' + result.GET_ROUTE_BY_USUARIO_ID[0].ProductoCodigo
                    + (result.GET_ROUTE_BY_USUARIO_ID[0].CategoriaCodigo ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].CategoriaCodigo : "")
                    + (result.GET_ROUTE_BY_USUARIO_ID[0].ProgramaCodigo ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].ProgramaCodigo : "")
                    + (result.GET_ROUTE_BY_USUARIO_ID[0].CodigoPantalla ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].CodigoPantalla : "")
                ) : undefined;

            let initialProduct = {};
            let rowsPerProduct = {};            
            let initialProgram = {};
            let rowsPerProgram = {};

            if (result.GET_PRODUCTO_USUARIO_LOGIN.length > 0) {
                initialProduct = result.GET_PRODUCTO_USUARIO_LOGIN[0].ProductoId;
                rowsPerProduct = result.GET_PRODUCTO_USUARIO_LOGIN.filter(
                    x => x.ProductoId != initialProduct
                );

                initialProgram = result.GET_PRODUCTO_USUARIO_LOGIN[0].ProgramaId;
                rowsPerProgram = result.GET_PRODUCTO_USUARIO_LOGIN.filter(
                    x => x.ProgramaId != initialProgram
                );
            }

            LogHelper.Out(menuProductos.name);
            return {
                ...state,
                branchId: result.GetInitialData.result.SucursalId,
                branchDescription: result.GetInitialData.result.Descripcion,
                login: result.GetInitialData.result.LOGIN,
                userName: result.GetInitialData.result.Nombre,
                hostName: result.GetInitialData.HostName,
                tiempo: result.GetInitialData.result.tiempo,
                menuUsuario: menuUsuario,
                isFetching: false,

                startUpSelected: result.GET_ROUTE_BY_USUARIO_ID.length > 0 ? routes : null,
                productoId: result.GET_ROUTE_BY_USUARIO_ID.length > 0 ? result.GET_ROUTE_BY_USUARIO_ID[0].IdProducto : 0,       
                programCategories: [], 
                categorySelected: result.GET_ROUTE_BY_USUARIO_ID.length > 0 ? result.GET_ROUTE_BY_USUARIO_ID[0].CategoriaCodigo : 0,
                productoCodigo: result.GET_ROUTE_BY_USUARIO_ID.length > 0 ? result.GET_ROUTE_BY_USUARIO_ID[0].ProductoCodigo : null,
                productosCount: result.GET_PRODUCTO_USUARIO_LOGIN.length,

                defaultProducto: rowsPerProduct.length == 0 ? result.GET_PRODUCTO_USUARIO_LOGIN[0] : null,
                defaultPrograma: rowsPerProgram.length == 0 ? result.GET_PRODUCTO_USUARIO_LOGIN[0] : null,

                primerLogin: result.GetInitialData.result.PrimerLogin,
                solicitarContrasenia: result.GET_CONFIGURATION_PASSWORD_TYPE[0].SolicitarContrasenia,
                tipoSeguridad: result.GET_CONFIGURATION_PASSWORD_TYPE[0].TipoSeguridad,
                soloUsuarioLoggeado: result.GET_CONFIGURATION_PASSWORD_TYPE[0].SoloUsuarioLoggeado,

                menuLoaded: true
            };

        case GET_MENU_USUARIO_DATA_FAILURE:
            LogHelper.Out(menuProductos.name);
            return { ...state, isFetching: false, error: true, menuLoaded: false };

        case SET_PROGRAMA_ACTUAL:
            LogHelper.Out(menuProductos.name);
            return { ...state, lastProgram: action.programaActual };

        case RESET_MENU_PRODUCTOS:
            LogHelper.Out(menuProductos.name);
            return initialState;

        case INITIAL_PRODUCTO_SELECTED_TOP_MENU:
            LogHelper.Out(menuProductos.name);

            return {
                ...state,
                productoId: action.productId
            };

        case INITIAL_PROGRAM_SELECTED_TOP_MENU:

            LogHelper.Out(menuProductos.name);

            return {
                ...state,
                categorySelected: action.categorySelected
            };

        case POP_UP_OPEN:
            LogHelper.Out(menuProductos.name);
            return { ...state };

        case POP_UP_PRODUCTO_SELECTED:
            LogHelper.Out(menuProductos.name);

            let categoryList;

            action.productList.forEach(function (element) {
                if (element.id == action.productId)
                    categoryList = element.categorias;
            })

            return {
                ...state,
                programCategories: categoryList,
                categorySelected: null,
                defaultProducto:null,
            };

        case POP_UP_PROGRAMA_OPEN:
            LogHelper.Out(menuProductos.name);

            return {
                ...state,
                categorySelected: state.programCategories[0].id
            };

        case POP_UP_PROGRAMA_CLOSE:
            LogHelper.Out(menuProductos.name);
            return {
                ...state,
                flagAccesoDirecto: false,
                productoId: null,
                programCategories: [],
                categorySelected: null,
                productoCodigo: null,
            };

        case ACCESO_DIRECTO_POP_UP_PROGRAMA:
            LogHelper.Out(menuProductos.name);
            return {
                ...state,
                flagAccesoDirecto: true,
                defaultProducto: action.defaultProducto
            };

        case INITIAL_PROGRAM_SAVE_TOP_MENU:

            var result = {
                'GET_ROUTE_BY_USUARIO_ID': JSON.parse(action.data.GET_ROUTE_BY_USUARIO_ID).Recordset0.Rows
            }

            routes = result.GET_ROUTE_BY_USUARIO_ID.length > 0 ?
                ('#/' + result.GET_ROUTE_BY_USUARIO_ID[0].ProductoCodigo
                      + (result.GET_ROUTE_BY_USUARIO_ID[0].CategoriaCodigo ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].CategoriaCodigo : "")
                      + (result.GET_ROUTE_BY_USUARIO_ID[0].ProgramaCodigo ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].ProgramaCodigo : "") 
                      + (result.GET_ROUTE_BY_USUARIO_ID[0].CodigoPantalla ? '/' + result.GET_ROUTE_BY_USUARIO_ID[0].CodigoPantalla : "") 
                 ) : undefined;

            LogHelper.Out(menuProductos.name);
            return {
                ...state,
                startUpSelected: result.GET_ROUTE_BY_USUARIO_ID.length > 0 ? routes : null,
                flagAccesoDirecto: false,
                productoId: null,
                programCategories: [],
                categorySelected: null,
                productoCodigo: null,
                primerLogin: true
            };
        case SET_FLAG_ACCESO_DIRECTO:
            return {
                ...state,
                flagAccesoDirecto: false
            }
        default:
            LogHelper.Out(menuProductos.name);
            return state;
    }
}

export default menuProductos;



// WEBPACK FOOTER //
// ./Portico/App/store/Reducers/MenuProductos.js